import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const businessRegistrationSerializeMap: SerializeMap<BusinessRegistration> = {
  id: "id",
  abn: "abn",
  acn: "acn",
  tradingName: "trading_name",
  legalName: "legal_name",
  isABNActive: "is_abn_active",
  isGSTRegistered: "is_gst_registered",
  gstRegisteredFrom: "gst_registered_from",
  gstRegisteredTo: "gst_registered_to",
  abrLastChecked: "abr_last_checked",
};

export const serializeBusinessRegistration = buildSerializer(
  businessRegistrationSerializeMap,
  "businessRegistration",
);

export const deserializeBusinessRegistration =
  buildDeserializer<BusinessRegistration>(
    businessRegistrationSerializeMap,
    "businessRegistration",
  );
